/* FORCE ADD TO CART TO OPEN SOCNFDNT SIDE DRAWER */

(() => {
  if (window.socForcedCartDrawerInstalled) return;
  window.socForcedCartDrawerInstalled = true;

  const root = window.Shopify?.routes?.root || "/";

  function getCartFormFromEvent(event) {
    const clickedButton = event.target.closest(
      'button[name="add"], button[type="submit"], input[type="submit"], .product-form__submit'
    );

    if (!clickedButton) return null;

    return clickedButton.closest('form[action*="/cart/add"]');
  }

  async function addFormToCart(form, submitButton) {
    if (!form) return;

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.classList.add("is-loading");
    }

    try {
      const formData = new FormData(form);

      const response = await fetch(`${root}cart/add.js`, {
        method: "POST",
        headers: {
          Accept: "application/json"
        },
        body: formData
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.description || data.message || "Could not add item to cart.");
      }

      if (window.socCartDrawer) {
        await window.socCartDrawer.load();
        window.socCartDrawer.open();
        return;
      }

      const cartButton = document.querySelector("[data-soc-cart-open]");

      if (cartButton) {
        cartButton.click();
        return;
      }

      window.location.href = `${root}cart`;
    } catch (error) {
      alert(error.message || "Could not add item to cart.");
    } finally {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.classList.remove("is-loading");
      }
    }
  }

  document.addEventListener(
    "click",
    async (event) => {
      const form = getCartFormFromEvent(event);

      if (!form) return;

      const submitButton = event.target.closest(
        'button[name="add"], button[type="submit"], input[type="submit"], .product-form__submit'
      );

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      await addFormToCart(form, submitButton);
    },
    true
  );

  document.addEventListener(
    "submit",
    async (event) => {
      const form = event.target.closest('form[action*="/cart/add"]');

      if (!form) return;

      const submitButton = form.querySelector(
        'button[name="add"], button[type="submit"], input[type="submit"], .product-form__submit'
      );

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      await addFormToCart(form, submitButton);
    },
    true
  );
})();

document.addEventListener("DOMContentLoaded", () => {
  const config = document.querySelector(".soc-reviews-live-config");
  const grid = document.querySelector("#soc-live-reviews");

  if (!config || !grid) return;

  const apiUrl = config.dataset.reviewsApi;

  if (!apiUrl) return;

  async function loadReviews() {
    try {
      const response = await fetch(apiUrl, {
        headers: {
          "Accept": "application/json"
        }
      });

      if (!response.ok) return;

      const reviews = await response.json();

      if (!Array.isArray(reviews) || reviews.length === 0) return;

      grid.innerHTML = reviews.slice(0, 6).map((review) => {
        const name = escapeHtml(review.name || "Client");
        const role = escapeHtml(review.role || "Socnfdnt Client");
        const text = escapeHtml(review.review || "");
        const stars = Number(review.stars || 5);

        return `
          <div class="soc-review-card">
            <div class="soc-review-top">
              <div class="soc-review-avatar-fallback">
                ${name.charAt(0).toUpperCase()}
              </div>

              <div>
                <h3>${name}</h3>
                <p>${role}</p>
              </div>
            </div>

            <div class="soc-review-stars">
  ${Array.from({ length: Math.min(Math.max(stars, 1), 5) }, () => "<span>★</span>").join("")}
</div>

            <p class="soc-review-text">“${text}”</p>
          </div>
        `;
      }).join("");
    } catch (error) {
      console.warn("Socnfdnt reviews failed to load:", error);
    }
  }

  function escapeHtml(value) {
    return String(value)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  loadReviews();

  // Refresh every 60 seconds for near-live updates
  setInterval(loadReviews, 60000);
});

document.addEventListener("DOMContentLoaded", () => {
  const search = document.querySelector("[data-soc-search]");

  if (!search) return;

  const toggle = search.querySelector(".soc-search-toggle");
  const form = search.querySelector(".soc-search-form");
  const input = search.querySelector(".soc-search-input");
  const resultsBox = search.querySelector(".soc-search-results");
  const resultsInner = search.querySelector(".soc-search-results-inner");

  let searchTimer = null;
  let searchController = null;

  function openSearch() {
    search.classList.add("is-open");

    setTimeout(() => {
      input.focus();
    }, 50);
  }

  function closeSearch() {
    search.classList.remove("is-open");
    resultsBox.hidden = true;
  }

  function escapeHtml(value) {
    return String(value || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function getProductImage(product) {
    if (!product) return "";

    if (typeof product.image === "string") {
      return product.image;
    }

    if (product.image && product.image.url) {
      return product.image.url;
    }

    if (product.featured_image && product.featured_image.url) {
      return product.featured_image.url;
    }

    return "";
  }

  function formatPrice(product) {
    const value = product.price || product.price_min || "";

    if (!value) return "";

    if (typeof value === "string") {
      return value.replace(/<[^>]*>/g, "");
    }

    const number = Number(value);

    if (Number.isNaN(number)) return "";

    const currency = window.Shopify?.currency?.active || "USD";

    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency
    }).format(number / 100);
  }

  function fallbackIcon() {
    return `
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none">
        <path d="M6 7.5L12 4L18 7.5V16.5L12 20L6 16.5V7.5Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
        <path d="M6.5 8L12 11.2L17.5 8" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
        <path d="M12 11.2V19.3" stroke="currentColor" stroke-width="2"/>
      </svg>
    `;
  }

  function renderResults(products) {
    if (!Array.isArray(products) || products.length === 0) {
      resultsInner.innerHTML = `<div class="soc-search-empty">No products found.</div>`;
      resultsBox.hidden = false;
      return;
    }

    resultsInner.innerHTML = products.slice(0, 10).map((product) => {
      const title = escapeHtml(product.title);
      const url = product.url || "#";
      const image = getProductImage(product);
      const price = escapeHtml(formatPrice(product));

      return `
        <a href="${url}" class="soc-search-item">
          <div class="soc-search-thumb">
            ${
              image
                ? `<img src="${escapeHtml(image)}" alt="${title}">`
                : fallbackIcon()
            }
          </div>

          <div class="soc-search-info">
            <p class="soc-search-title">${title}</p>
            ${price ? `<p class="soc-search-price">${price}</p>` : ""}
          </div>
        </a>
      `;
    }).join("");

    resultsBox.hidden = false;
  }

  async function runSearch(query) {
    if (searchController) {
      searchController.abort();
    }

    searchController = new AbortController();

    resultsInner.innerHTML = `<div class="soc-search-loading">Searching...</div>`;
    resultsBox.hidden = false;

    try {
      const endpoint = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last`;

      const response = await fetch(endpoint, {
        headers: {
          Accept: "application/json"
        },
        signal: searchController.signal
      });

      if (!response.ok) {
        resultsInner.innerHTML = `<div class="soc-search-empty">Search failed.</div>`;
        return;
      }

      const data = await response.json();
      const products = data?.resources?.results?.products || [];

      renderResults(products);
    } catch (error) {
      if (error.name === "AbortError") return;

      resultsInner.innerHTML = `<div class="soc-search-empty">Search failed.</div>`;
      resultsBox.hidden = false;
    }
  }

  toggle.addEventListener("click", (event) => {
    event.preventDefault();
    openSearch();
  });

  input.addEventListener("input", () => {
    const query = input.value.trim();

    clearTimeout(searchTimer);

    if (query.length < 2) {
      resultsBox.hidden = true;
      return;
    }

    searchTimer = setTimeout(() => {
      runSearch(query);
    }, 250);
  });

  form.addEventListener("submit", (event) => {
    if (!input.value.trim()) {
      event.preventDefault();
      openSearch();
    }
  });

  document.addEventListener("click", (event) => {
    if (!search.contains(event.target)) {
      closeSearch();
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeSearch();
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const openButton = document.querySelector("[data-soc-services-open]");
  const popup = document.querySelector("[data-soc-services-popup]");
  const closeButtons = document.querySelectorAll("[data-soc-services-close]");

  if (!openButton || !popup) return;

  function openServicesPopup() {
    popup.classList.add("is-open");
    popup.setAttribute("aria-hidden", "false");
    document.body.classList.add("soc-services-popup-active");
  }

  function closeServicesPopup() {
    popup.classList.remove("is-open");
    popup.setAttribute("aria-hidden", "true");
    document.body.classList.remove("soc-services-popup-active");
  }

  openButton.addEventListener("click", openServicesPopup);

  closeButtons.forEach((button) => {
    button.addEventListener("click", closeServicesPopup);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeServicesPopup();
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const searchInput = document.querySelector("[data-soc-product-search]");
  const cards = document.querySelectorAll("[data-product-card]");
  const emptyState = document.querySelector("[data-soc-product-empty]");

  if (!searchInput || !cards.length) return;

  searchInput.addEventListener("input", () => {
    const query = searchInput.value.trim().toLowerCase();
    let visibleCount = 0;

    cards.forEach((card) => {
      const title = card.dataset.productTitle || "";
      const isVisible = title.includes(query);

      card.style.display = isVisible ? "" : "none";

      if (isVisible) {
        visibleCount += 1;
      }
    });

    if (emptyState) {
      emptyState.hidden = visibleCount !== 0;
    }
  });
});

 /* SOCNFDNT PRODUCT MEDIA SWITCHER */

document.addEventListener("DOMContentLoaded", () => {
  const mediaItems = document.querySelectorAll("[data-soc-product-media]");
  const mediaThumbs = document.querySelectorAll("[data-soc-product-media-thumb]");

  if (!mediaItems.length || !mediaThumbs.length) return;

  function pauseAllVideos() {
    mediaItems.forEach((item) => {
      const video = item.querySelector("video");

      if (video) {
        video.pause();
      }
    });
  }

  mediaThumbs.forEach((thumb) => {
    thumb.addEventListener("click", (event) => {
      event.preventDefault();

      const mediaId = thumb.dataset.socProductMediaThumb;

      if (!mediaId) return;

      pauseAllVideos();

      mediaItems.forEach((item) => {
        const isActive = item.dataset.socProductMedia === mediaId;
        item.classList.toggle("is-active", isActive);
      });

      mediaThumbs.forEach((button) => {
        const isActive = button.dataset.socProductMediaThumb === mediaId;
        button.classList.toggle("is-active", isActive);
      });

      const activeMedia = document.querySelector(`[data-soc-product-media="${mediaId}"]`);
      const activeVideo = activeMedia?.querySelector("video");

      if (activeVideo) {
        activeVideo.currentTime = 0;
      }
    });
  });
});

/* CUSTOM AJAX PRODUCT ADD BUTTONS WITH REQUIRED PRODUCT DETAILS */

document.addEventListener("DOMContentLoaded", () => {
  const ajaxButtons = document.querySelectorAll("[data-soc-ajax-add]");

  ajaxButtons.forEach((button) => {
    button.addEventListener("click", async () => {
      const form = button.closest("[data-soc-ajax-product-form]");
      if (!form) return;

      const message = form.querySelector("[data-soc-cart-message]");
      const root = window.Shopify?.routes?.root || "/";

      const productHandle = form.dataset.productHandle;
      const variantId = Number(form.dataset.variantId);

      function showMessage(text) {
        if (!message) {
          alert(text);
          return;
        }

        message.hidden = false;
        message.textContent = text;
      }

      function clearMessage() {
        if (!message) return;

        message.hidden = true;
        message.textContent = "";
      }

      function collectProperties() {
        const fields = form.querySelectorAll('[name^="properties["]');
        const properties = {};
        let valid = true;
        let firstInvalid = null;

        fields.forEach((field) => {
          const match = field.name.match(/^properties\[(.+)\]$/);
          if (!match) return;

          const key = match[1];
          const value = field.value.trim();

          field.classList.remove("is-error");

          if (field.hasAttribute("required") && !value) {
            valid = false;
            field.classList.add("is-error");

            if (!firstInvalid) {
              firstInvalid = field;
            }
          }

          if (field.hasAttribute("minlength")) {
            const min = Number(field.getAttribute("minlength"));

            if (value.length < min) {
              valid = false;
              field.classList.add("is-error");

              if (!firstInvalid) {
                firstInvalid = field;
              }
            }
          }

          if (value) {
            properties[key] = value;
          }
        });

        return {
          valid,
          firstInvalid,
          properties
        };
      }

      if (!productHandle || !variantId) {
        showMessage("Missing product or variant data.");
        return;
      }

      const propertyData = collectProperties();

      if (!propertyData.valid) {
        showMessage("Please fill out your name and product details before adding this item to cart.");

        if (propertyData.firstInvalid) {
          propertyData.firstInvalid.focus();
        }

        return;
      }

      button.disabled = true;
      button.classList.add("is-loading");
      clearMessage();

      try {
        const productResponse = await fetch(`${root}products/${productHandle}.js`, {
          headers: {
            Accept: "application/json"
          }
        });

        if (!productResponse.ok) {
          throw new Error("Could not load product selling plan.");
        }

        const productData = await productResponse.json();
        const variant = productData.variants.find((item) => Number(item.id) === variantId);

        if (!variant) {
          throw new Error("Could not find this product variant.");
        }

        let sellingPlanId = null;

        if (
          Array.isArray(variant.selling_plan_allocations) &&
          variant.selling_plan_allocations.length > 0
        ) {
          sellingPlanId = variant.selling_plan_allocations[0].selling_plan_id;
        }

        if (
          !sellingPlanId &&
          Array.isArray(productData.selling_plan_groups) &&
          productData.selling_plan_groups.length > 0 &&
          Array.isArray(productData.selling_plan_groups[0].selling_plans) &&
          productData.selling_plan_groups[0].selling_plans.length > 0
        ) {
          sellingPlanId = productData.selling_plan_groups[0].selling_plans[0].id;
        }

        const item = {
          id: variantId,
          quantity: 1,
          properties: propertyData.properties
        };

        if (sellingPlanId) {
          item.selling_plan = Number(sellingPlanId);
        }

        const cartResponse = await fetch(`${root}cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            items: [item]
          })
        });

        const cartData = await cartResponse.json();

        if (!cartResponse.ok) {
          throw new Error(cartData.description || cartData.message || "Could not add product to cart.");
        }

        if (window.socCartDrawer) {
          await window.socCartDrawer.load();
          window.socCartDrawer.open();
        } else {
          window.location.href = `${root}cart`;
        }
      } catch (error) {
        showMessage(error.message);
      } finally {
        button.disabled = false;
        button.classList.remove("is-loading");
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const drawer = document.querySelector("[data-soc-cart-drawer]");
  const openButtons = document.querySelectorAll("[data-soc-cart-open]");
  const closeButtons = document.querySelectorAll("[data-soc-cart-close]");
  const itemsContainer = document.querySelector("[data-soc-cart-items]");
  const totalEl = document.querySelector("[data-soc-cart-total]");
  const countEls = document.querySelectorAll("[data-soc-cart-count]");
  const progressText = document.querySelector("[data-soc-cart-progress-text]");
  const progressBar = document.querySelector("[data-soc-cart-progress-bar]");
  const discountInput = document.querySelector("[data-soc-discount-input]");
  const discountButton = document.querySelector("[data-soc-apply-discount]");

  if (!drawer || !itemsContainer) return;

  const root = window.Shopify?.routes?.root || "/";

  function money(cents, currency = "USD") {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency
    }).format((Number(cents) || 0) / 100);
  }

  function escapeHtml(value) {
    return String(value || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function openCart() {
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("soc-cart-open");
    loadCart();
  }

  function closeCart() {
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("soc-cart-open");
  }

  async function loadCart() {
    const response = await fetch(`${root}cart.js`, {
      headers: {
        Accept: "application/json"
      }
    });

    const cart = await response.json();
    renderCart(cart);
  }

  function renderCart(cart) {
    const currency = cart.currency || window.Shopify?.currency?.active || "USD";

    countEls.forEach((el) => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? "inline-flex" : "none";
    });

    if (totalEl) {
      totalEl.textContent = money(cart.total_price, currency);
    }

    const premiumGoal = 25000;
const premiumCode = "PREMIUM250";
const percent = Math.min((cart.total_price / premiumGoal) * 100, 100);

const premiumStatus = document.querySelector("[data-soc-premium-status]");
const premiumCodeBox = document.querySelector("[data-soc-premium-code]");
const premiumApplyButton = document.querySelector("[data-soc-premium-apply]");

if (progressBar) {
  progressBar.style.width = `${percent}%`;
}

if (progressText) {
  if (cart.total_price >= premiumGoal) {
    progressText.textContent = "Premium Member checkout perk unlocked.";
  } else {
    progressText.textContent = `Spend ${money(premiumGoal - cart.total_price, currency)} more to unlock Premium Member checkout perks.`;
  }
}

if (premiumStatus) {
  if (cart.total_price >= premiumGoal) {
    premiumStatus.textContent = "Unlocked";
    premiumStatus.classList.add("is-unlocked");
  } else {
    premiumStatus.textContent = "Locked";
    premiumStatus.classList.remove("is-unlocked");
  }
}

const premiumUnlocked = cart.total_price >= premiumGoal;

if (premiumCodeBox) {
  premiumCodeBox.hidden = !premiumUnlocked;
}

if (premiumApplyButton) {
  premiumApplyButton.hidden = !premiumUnlocked;
  premiumApplyButton.dataset.premiumUnlocked = premiumUnlocked ? "true" : "false";
}

    if (!cart.items || cart.items.length === 0) {
      itemsContainer.innerHTML = `
        <div class="soc-cart-empty">
          Your cart is empty.
        </div>
      `;
      return;
    }

    itemsContainer.innerHTML = cart.items.map((item) => {
      const image = item.image
        ? `<img src="${item.image}" alt="${escapeHtml(item.product_title)}">`
        : "";

      const plan = item.selling_plan_allocation?.selling_plan?.name
        ? `<p class="soc-cart-item-plan">${escapeHtml(item.selling_plan_allocation.selling_plan.name)}</p>`
        : "";

        const properties = item.properties && Object.keys(item.properties).length
  ? `
    <div class="soc-cart-item-properties">
      ${Object.entries(item.properties).map(([key, value]) => {
        if (!value || key.startsWith("_")) return "";

        return `
          <p>
            <span>${escapeHtml(key)}:</span>
            ${escapeHtml(value)}
          </p>
        `;
      }).join("")}
    </div>
  `
  : "";

      return `
        <div class="soc-cart-item" data-cart-key="${escapeHtml(item.key)}">
          <a href="${item.url}" class="soc-cart-item-img">
            ${image}
          </a>

          <div class="soc-cart-item-info">
            <a href="${item.url}" class="soc-cart-item-title">
              ${escapeHtml(item.product_title)}
            </a>

            ${plan}
            ${properties}

            <p class="soc-cart-item-price">
              ${money(item.final_line_price, currency)}
            </p>

            <div class="soc-cart-item-bottom">
              <div class="soc-cart-qty">
                <button type="button" data-cart-qty="-1">−</button>
                <span>${item.quantity}</span>
                <button type="button" data-cart-qty="1">+</button>
              </div>

              <button type="button" class="soc-cart-remove" data-cart-remove>
                Remove
              </button>
            </div>
          </div>
        </div>
      `;
    }).join("");
  }

  window.socCartDrawer = {
  open: openCart,
  close: closeCart,
  load: loadCart
};

  async function changeItem(key, quantity) {
    const response = await fetch(`${root}cart/change.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        id: key,
        quantity
      })
    });

    const cart = await response.json();
    renderCart(cart);
  }

  openButtons.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault();
      openCart();
    });
  });

  document.querySelectorAll('a[href="/cart"], a[href="/cart/"]').forEach((link) => {
    link.addEventListener("click", (event) => {
      event.preventDefault();
      openCart();
    });
  });

  closeButtons.forEach((button) => {
    button.addEventListener("click", closeCart);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeCart();
    }
  });

  itemsContainer.addEventListener("click", (event) => {
    const item = event.target.closest("[data-cart-key]");
    if (!item) return;

    const key = item.dataset.cartKey;
    const qtyButton = event.target.closest("[data-cart-qty]");
    const removeButton = event.target.closest("[data-cart-remove]");

    const currentQty = Number(item.querySelector(".soc-cart-qty span")?.textContent || 1);

    if (qtyButton) {
      const change = Number(qtyButton.dataset.cartQty);
      const nextQty = Math.max(currentQty + change, 0);
      changeItem(key, nextQty);
    }

    if (removeButton) {
      changeItem(key, 0);
    }
  });

  if (discountButton && discountInput) {
    discountButton.addEventListener("click", () => {
      const code = discountInput.value.trim();

      if (!code) return;

      window.location.href = `${root}discount/${encodeURIComponent(code)}?redirect=/checkout`;
    });
  }

  const premiumApplyButton = document.querySelector("[data-soc-premium-apply]");

if (premiumApplyButton) {
  premiumApplyButton.addEventListener("click", () => {
    const isUnlocked = premiumApplyButton.dataset.premiumUnlocked === "true";

    if (!isUnlocked) {
      return;
    }

    window.location.href = `${root}discount/PREMIUM250?redirect=/checkout`;
  });
}

  loadCart();
});

document.addEventListener("DOMContentLoaded", () => {
  const inquiryMessage = document.querySelector("[data-soc-inquiry-message]");
  const inquiryCount = document.querySelector("[data-soc-inquiry-count]");

  if (!inquiryMessage || !inquiryCount) return;

  function updateInquiryCount() {
    const length = inquiryMessage.value.trim().length;

    inquiryCount.textContent = length;

    if (length < 150) {
      inquiryMessage.setCustomValidity("Please enter at least 150 characters for your inquiry.");
    } else {
      inquiryMessage.setCustomValidity("");
    }
  }

  inquiryMessage.addEventListener("input", updateInquiryCount);
  updateInquiryCount();
});

/* SOCNFDNT LIVE AGENT CHAT BUTTON - SAFE FALLBACK */

document.addEventListener("DOMContentLoaded", () => {
  const liveAgentLinks = document.querySelectorAll(
    'a[href="#live-agent-chat"], [data-soc-live-agent-open]'
  );

  function showChatHint() {
    const oldHint = document.querySelector(".soc-chat-hint");
    if (oldHint) oldHint.remove();

    const hint = document.createElement("div");
    hint.className = "soc-chat-hint";
    hint.innerHTML = `
      <strong>Live chat is ready</strong>
      <span>Click the chat bubble in the bottom-right corner.</span>
    `;

    document.body.appendChild(hint);

    setTimeout(() => {
      hint.classList.add("is-visible");
    }, 50);

    setTimeout(() => {
      hint.classList.remove("is-visible");

      setTimeout(() => {
        hint.remove();
      }, 400);
    }, 4500);
  }

  liveAgentLinks.forEach((link) => {
    link.addEventListener("click", (event) => {
      event.preventDefault();
      showChatHint();
    });
  });
});